import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import classnames from 'classnames';
import { Component } from '@wordpress/element';
import { ENTER } from '@wordpress/keycodes';
import PropTypes from 'prop-types';
/**
 * WooCommerce dependencies
 */

import Link from '../link';
/**
 * List component to display a list of items.
 */

var List =
/*#__PURE__*/
function (_Component) {
  _inherits(List, _Component);

  function List() {
    _classCallCheck(this, List);

    return _possibleConstructorReturn(this, _getPrototypeOf(List).apply(this, arguments));
  }

  _createClass(List, [{
    key: "handleKeyDown",
    value: function handleKeyDown(event, onClick) {
      if ('function' === typeof onClick && event.keyCode === ENTER) {
        onClick();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          className = _this$props.className,
          items = _this$props.items;
      var listClassName = classnames('woocommerce-list', className);
      return createElement("ul", {
        className: listClassName,
        role: "menu"
      }, items.map(function (item, i) {
        var after = item.after,
            before = item.before,
            itemClasses = item.className,
            content = item.content,
            href = item.href,
            onClick = item.onClick,
            target = item.target,
            title = item.title;
        var hasAction = 'function' === typeof onClick || href;
        var itemClassName = classnames('woocommerce-list__item', itemClasses, {
          'has-action': hasAction
        });
        var InnerTag = href ? Link : 'div';
        var innerTagProps = {
          className: 'woocommerce-list__item-inner',
          onClick: 'function' === typeof onClick ? onClick : null,
          'aria-disabled': hasAction ? 'false' : null,
          tabIndex: hasAction ? '0' : null,
          role: hasAction ? 'menuitem' : null,
          onKeyDown: function onKeyDown(e) {
            return hasAction ? _this.handleKeyDown(e, onClick) : null;
          },
          target: href ? target : null,
          type: href ? 'external' : null,
          href: href
        };
        return createElement("li", {
          className: itemClassName,
          key: i
        }, createElement(InnerTag, innerTagProps, before && createElement("div", {
          className: "woocommerce-list__item-before"
        }, before), createElement("div", {
          className: "woocommerce-list__item-text"
        }, createElement("span", {
          className: "woocommerce-list__item-title"
        }, title), content && createElement("span", {
          className: "woocommerce-list__item-content"
        }, content)), after && createElement("div", {
          className: "woocommerce-list__item-after"
        }, after)));
      }));
    }
  }]);

  return List;
}(Component);

List.propTypes = {
  /**
   * Additional class name to style the component.
   */
  className: PropTypes.string,

  /**
   * An array of list items.
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    /**
     * Content displayed after the list item text.
     */
    after: PropTypes.node,

    /**
     * Content displayed before the list item text.
     */
    before: PropTypes.node,

    /**
     * Additional class name to style the list item.
     */
    className: PropTypes.string,

    /**
     * Content displayed beneath the list item title.
     */
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

    /**
     * Href attribute used in a Link wrapped around the item.
     */
    href: PropTypes.string,

    /**
     * Called when the list item is clicked.
     */
    onClick: PropTypes.func,

    /**
     * Target attribute used for Link wrapper.
     */
    target: PropTypes.string,

    /**
     * Title displayed for the list item.
     */
    title: PropTypes.string.isRequired
  })).isRequired
};
export default List;
//# sourceMappingURL=index.js.map